export const DELETE_MODAL_MESSAGES = ({
  TITLE: 'Delete annotation',
  WARNING_MESSAGE: ' Are you sure you want to delete annotation with Id:',
  START_FRAME: 'Start frame',
  END_FRAME: 'End frame',
  MAX_VALUE: 'max value',
  MIN_VALUE: 'min value',
  CANCEL: 'Cancel',
  DELETE: 'Delete'
} as const);